<template>
  <div id="BookingItem">
    <div>
      <p class="booking-text bold">
        {{ getDateLineText(booking.start) }}
      </p>
      <p class="booking-text mb-2">Session with {{ booking.coach_title }}</p>
      <p class="booking-text">
        <i class="fa fa-clock mr-2" aria-hidden="true"></i>
        {{ getHoursMinutes(booking.start) }} -
        {{ getHoursMinutes(booking.end) }}
      </p>
    </div>
    <div class="d-flex flex-column align-items-end">
      <span class="booking-text booking-text-day mb-4">{{
        getDay(booking.start)
      }}</span>
      <span class="booking-text">{{ getMonth(booking.start) }}</span>
    </div>
    <b-button
      v-if="booking.delivery_type === 'video' 
      // && shouldShowLink // TODO: uncomment for prod
      "
      @click="openBookingPage(booking.id)"
      class="corner-btn"
    >
      <span>Start Video</span><i class="fas fa-video ml-2"></i>
    </b-button>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "BookingWithCoachCard",
  props: {
    booking: {
      type: Object,
      required: true,
      default: () => ({})
    }
  },
  data() {
    return {
      shouldShowLink: false
    };
  },
  mounted() {
    let self = this;
    let now = moment();
    let bookingStart = moment(this.booking.start);
    if (this.isEarliest) {
      if (now.isSameOrAfter(bookingStart.subtract(10, "minute"))) {
        this.shouldShowLink = true;
      } else {
        let offset = bookingStart.diff(now);
        if (offset < 2147483647) {
          setTimeout(() => {
            self.shouldShowLink = true;
          }, offset);
        }
      }
    }
  },
  methods: {
    openBookingPage(id) {
      this.$router.push("/booking-video-room/" + id + "/device-tests");
    }
  }
};
</script>

<style lang="less">
#BookingItem {
  position: relative;
  display: flex;
  max-width: 380px;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  color: #fff;
  background-color: #403d56;
  border-radius: 20px;
  border-bottom-right-radius: 0;
  box-shadow: 0px 4px 4px 0px #00000040;
  padding: 22px 22px 42px;

  p {
    color: #fff;
  }

  .booking-text {
    font-size: 2.2rem;
    line-height: 3.4rem;
    margin: 0;

    &.bold {
      font-family: "PlusJakartaSansBold";
    }
  }

  .booking-text-day {
    font-size: 5.8rem;
  }

  .corner-btn {
    position: absolute;
    bottom: 0;
    right: 0;
    height: 40px;
    width: 200px;
    padding: 8px 24px;
    border-radius: 20px 0px 0px 0px;
    letter-spacing: 0;
    background-color: #ed3a75;
    color: #fff;
    font-family: "PlusJakartaSansBold";
    font-size: 1.6rem;

    &:hover {
      background-color: #ed3a76d9;
    }
  }
}
</style>
